module.exports = __webpack_public_path__ + "static/img/dashboard-events.06b5122.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/dashboard-events.png
// module id = qAtb
// module chunks = 0